import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Chip, TableSortLabel, Typography } from "@mui/material";
import {
  typography,
  spacing,
  colors,
} from "../../../../../../../../../assets/styles/tokens";

type RrType = "success" | "warning" | "error";
export interface RevenueRow {
  cron_id: string;
  rrType: RrType;
  metric: string;
  actual_target: string;
  RR: string;
  PRR: string;
}
interface Props {
  TotalIncomeTableHeadings: { [key: string]: string };
  TotalIncomeTableRows: RevenueRow[];
}

const rrStyles = {
  success: {
    bg: colors.Success[50].$value,
    color: colors.Success[700].$value,
  },
  warning: {
    bg: colors.Warning[50].$value,
    color: colors.Warning[700].$value,
  },
  error: {
    bg: colors.Error[50].$value,
    color: colors.Error[600].$value,
  },
};

const PlayerValueTable = ({
  TotalIncomeTableHeadings,
  TotalIncomeTableRows,
}: Props) => {
  const headCells = Object.entries(TotalIncomeTableHeadings) as [
    keyof RevenueRow,
    string,
  ][];

  return (
    <>
      <Table size="small">
        <TableHead sx={{ background: colors.GrayLightMode[100].$value }}>
          <TableRow>
            {headCells.map(([_, value], index) => (
              <TableCell
                key={index}
                align="left"
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: typography.Size.Text.xs.$value,
                  fontWeight: typography.Font_weight.Regular.$value,
                  paddingX: spacing.Spacing.sm.$value,
                }}
              >
                <TableSortLabel>
                  {value && typeof value === "string" ? value : ""}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {TotalIncomeTableRows.map((row) => (
            <React.Fragment key={row.cron_id}>
              <TableRow
                sx={{
                  "& > *": {
                    borderBottom:
                      "1px solid " +
                      colors.GrayLightMode[200].$value +
                      "!important",
                  },
                }}
              >
                {headCells.map(([key], cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    align="left"
                    sx={{
                      // whiteSpace: "nowrap",
                      fontSize: typography.Size.Text.xs.$value,
                      fontWeight: typography.Font_weight.Regular.$value,
                      paddingX: spacing.Spacing.sm.$value,
                      paddingY: spacing.Spacing.xxs.$value,
                    }}
                  >
                    {key === "metric" ? (
                      <> {row[key] ? row[key] : "N/A"}</>
                    ) : key === "actual_target" ? (
                      <Typography
                        sx={{
                          fontWeight: typography.Font_weight.Semibold.$value,
                          fontSize: typography.Size.Text.xs.$value,
                        }}
                      >
                        {" "}
                        {row[key] ? row[key] : "N/A"}
                      </Typography>
                    ) : key === "RR" ? (
                      <Chip
                        label={row[key] ? row[key] : "N/A"}
                        size="small"
                        sx={{
                          bgcolor: rrStyles[row.rrType]?.bg,
                          color: rrStyles[row.rrType]?.color,
                          fontWeight: typography.Font_weight.Semibold.$value,
                          borderRadius: spacing.Radius.sm.$value,
                        }}
                      />
                    ) : key === "PRR" ? (
                      <Typography
                        sx={{
                          fontWeight: typography.Font_weight.Semibold.$value,
                          fontSize: typography.Size.Text.xs.$value,
                        }}
                      >
                        {" "}
                        {row[key] ? row[key] : "N/A"}
                      </Typography>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default PlayerValueTable;
